import React, { ReactElement } from 'react'

function S(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="6 6 12 12" stroke="rgba(0,0,0, 0.25)" strokeWidth="1" {...props}>
    <path d="M7 7L17 17M7 17L17 7" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
}

export default S
